import { useStores } from '../stores/store';
import { useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import SearchSchoolPage from './searchSchoolPage';
import { useTranslation } from 'react-i18next';
import { FaEye, FaEyeSlash } from 'react-icons/fa6';

function SignupDevicePage(props) {
	const { t } = useTranslation();
	const { auth } = useStores();
	const [error, setError] = useState<string>("");
	const { register: register, handleSubmit: handleSubmit, setValue: setValue, formState: formState } = useForm();
	// eslint-disable-next-line
	let navigate = useNavigate();
	const [searchParams, setSearchParams] = useSearchParams();

	const onSubmit = async data => {
		setError("");

		let res = await auth.registerNewDevice(data.activationCode);

		if (res == null) {
			setError(t('generalError'));
		} else if (!res || res.error) {
			setError(`${t('registrationFailed')}: ${res.msg}`);
		} else {
			if (res.success)
				navigate('/');
			else
				setError(`${t('registrationFailed')}: ${res.msg}`)
		}
	};

	const back = evt => {
		navigate(`/?key=${searchParams.get('key')}`);
	};

	return (
		<div className="grid h-screen place-items-center">
			<div className="w-full flex flex-col items-center justify-center">
				<img alt="" src="userIcon.png" />
				<form className="border-2 border-primary p-2 rounded-2xl flex flex-col items-center justify-center" onSubmit={handleSubmit(onSubmit)}>
					<label>{t('serialCode')} *:</label>
					<input {...register("activationCode", { required: true })} className="form-control mt-1 bg-primary-light rounded-lg p-1 outline-2 outline-primary" />
					{formState.errors.activationCode && <span className='text-red'>{t('fieldMandatory')}</span>}

					<button type="submit" className="bg-primary text-white text-center rounded-lg p-2 mt-4">
						{t('register')}
					</button>
				</form>

				{ error && error.length > 0 &&
					(
						<span className="text-primary mt-4">{error}</span>
					)
				}
				<button onClick={back} className="border-2 border-primary text-primary text-center rounded-lg p-2 mt-2 uppercase">
					{t('cancel')}
				</button>
			</div>
		</div>
	)
}

export default SignupDevicePage;